(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/dashboard/vehicleStatus/vehicleStatusWidget.tpl.html',
    '<div class="row" style="padding: 2.5px;"><div class="col-sm-12 col-md-12" style="padding: 2px"><div ng-if="isDataAvailable"><div class="buttonGroups" ng-repeat="buttonGroup in buttonGroups"><div class="buttonGroup" ng-repeat="button in buttonGroup.buttons"><button type="button" class="btn btn-default" ng-click="button.operation(button.operationParam)" ng-disabled="{{button.visibility}}"><span translate="{{button.name}}"></span></button></div></div></div><div ng-show="!isDataAvailable"><no-authorize></no-authorize></div></div></div>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/vehicleStatus/vehicleStatusWidget.tpl.js